<template>
  <div id="edit-profile-page">
    <dash-header :pages="breadCrumbsPages" :dashboardTitle="'User Profile'"></dash-header>
    <a-layout id="components-layout-demo-custom-trigger">
      <dash-sidebar
        defaultSelectedKeys="1"
        :menuItems="commonMenuItems.courseSubmitters"
        v-if="userRole === 'telas_course_submitters'"
      />
      <dash-sidebar
        defaultSelectedKeys="1"
        :menuItems="commonMenuItems.admin"
        v-else-if="userRole === 'telas_telas_administrator'"
      />
      <dash-sidebar
        defaultSelectedKeys="1"
        :menuItems="commonMenuItems.assessors"
        v-else
      />
      <a-layout>
        <a-layout-content
          :style="{
            margin: '24px 16px',
            padding: '24px',
            background: '#fff',
            minHeight: '280px',
          }"
        >
          <a-form
            id="register-form"
            :form="regForm"
            class="register-form"
            @submit="handleSubmit"
          >
            <a-alert
              v-if="errorMessage.length > 0"
              type="error"
              :message="errorMessage"
              banner
            />
            <a-alert
              v-if="successUpdate"
              type="success"
              :message="successMessage"
              banner
            />
            <br />
            <a-form-item v-bind="formItemLayout" label="First Name">
              <a-input
                v-decorator="[
                  'firstName',
                  {
                    initialValue: '',
                    rules: [{ required: true, message: 'Please enter your First Name.' }],
                  },
                ]"
                placeholder="First Name"
              >
              </a-input>
            </a-form-item>
            <a-form-item v-bind="formItemLayout" label="Last Name">
              <a-input
                v-decorator="[
                  'lastName',
                  {
                    initialValue: '',
                    rules: [{ required: true, message: 'Please enter your Last Name.' }],
                  },
                ]"
                placeholder="Last Name"
              >
              </a-input>
            </a-form-item>
            <a-form-item v-bind="formItemLayout" label="Position">
              <a-input
                v-decorator="[
                  'position',
                  {
                    initialValue: '',
                    rules: [{ required: true, message: 'Please enter your Postion' }],
                  },
                ]"
                placeholder="Position"
              >
              </a-input>
            </a-form-item>
            <a-form-item v-bind="formItemLayout" label="Faculty/Dept">
              <a-input
                v-decorator="[
                  'faculty',
                  {
                    initialValue: '',
                    rules: [
                      { required: true, message: 'Please enter your Faculty/Dept' },
                    ],
                  },
                ]"
                placeholder="Faculty/Dept"
              >
              </a-input>
            </a-form-item>
            <a-form-item v-bind="formItemLayout" label="Institution Name">
              <a-input
                v-decorator="[
                  'institutionName',
                  {
                    initialValue: '',
                    rules: [
                      {
                        required: true,
                        message: 'Please enter the name of the institution.',
                      },
                    ],
                  },
                ]"
                placeholder="institution Name"
              >
              </a-input>
            </a-form-item>
            <a-form-item v-bind="formItemLayout" label="Institution Campus">
              <a-input
                v-decorator="[
                  'institutionCampus',
                  {
                    initialValue: '',
                    rules: [
                      {
                        required: true,
                        message: 'Please enter the name of the institution Campus.',
                      },
                    ],
                  },
                ]"
                placeholder="institution Campus"
              >
              </a-input>
            </a-form-item>
            <a-form-item v-bind="formItemLayout" label="Institution State / Region">
              <a-input
                v-decorator="[
                  'institutionState',
                  {
                    initialValue: '',
                    rules: [
                      {
                        required: true,
                        message: 'Please enter your Institution State / Region.',
                      },
                    ],
                  },
                ]"
                placeholder="Institution State / Region"
              >
              </a-input>
            </a-form-item>
            <a-form-item v-bind="formItemLayout" label="Institution Country">
              <a-input
                v-decorator="[
                  'institutionCountry',
                  {
                    initialValue: '',
                    rules: [
                      {
                        required: true,
                        message: 'Please enter Institution Country',
                      },
                    ],
                  },
                ]"
                placeholder="Institution Country"
              >
              </a-input>
            </a-form-item>
            <a-form-item v-bind="formItemLayout" label="Email Address">
              <a-input
                v-decorator="[
                  'email',
                  {
                    initialValue: '',
                    rules: [
                      {
                        required: true,
                        message: 'Please enter your valid Email Address',
                      },
                      {
                        type: 'email',
                        message: 'Please enter your valid Email Address',
                      },
                    ],
                  },
                ]"
                placeholder="Email Address"
                type="email"
              >
              </a-input>
            </a-form-item>
            <a-form-item
              v-bind="formItemLayout"
              v-if="
                isActivated === 'no' ||
                (this.$route.name !== 'my-profile' &&
                  userRole === 'telas_telas_administrator')
              "
            >
              <span slot="label">
                TELAS Role
                <a-tooltip
                  title="Select interim reviewer if you have
          attended a certification workshop and wish to conduct your test assessments."
                >
                  <a-icon type="question-circle-o" />
                </a-tooltip>
              </span>
              <a-select
                placeholder="TELAS Role"
                style="width: 100%"
                :filterOption="false"
                v-decorator="[
                  'telasRole',
                  {
                    initialValue: userRole,
                    rules: [{ required: true, message: 'Please select one option.' }],
                  },
                ]"
              >
                <a-select-option
                  v-for="(roleValue, rolekey) in telasRoleObj"
                  :key="rolekey"
                  :value="rolekey"
                  >{{ roleValue }}</a-select-option
                >
              </a-select>
            </a-form-item>
            <a-form-item v-bind="tailFormItemLayout">
              <a-button type="primary" html-type="submit" class="login-form-button">
                Submit
              </a-button>
            </a-form-item>
          </a-form>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import router from "@src/router";
import dashSidebar from "./Sidebar.vue";
import dashHeader from "./Header.vue";

export default {
  name: "edit-profile",
  components: {
    dashSidebar,
    dashHeader,
  },
  data() {
    return {
      errorMessage: "",
      successUpdate: false,
      formItemLayout: {
        labelCol: {
          xs: {
            span: 24,
          },
          sm: {
            span: 8,
          },
        },
        wrapperCol: {
          xs: {
            span: 16,
          },
          sm: {
            span: 8,
          },
        },
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0,
          },
          sm: {
            span: 8,
            offset: 8,
          },
        },
      },
      telasRoleObj: {
        "": "Select One",
        telas_course_submitters: "Course Submitter",
        telas_admin_reviewers: "Admin Reviewer",
        telas_interim_reviewers: "Interim Reviewer",
        telas_certified_reviewers: "Certified Reviewer",
      },
      successMessage: "",
      breadCrumbsPages: [
        {
          name: "Home",
          route: "/",
        },
        {
          name: "Dashboard",
          route: "/dashboard",
        },
        {
          name: "Edit Profile",
          route: `/dashboard/edit-profile/${this.$route.params.userID}`,
        },
      ],
      dashboardTitle: "",
    };
  },
  computed: {
    ...mapGetters("dashboard", {
      userDetails: "getUserProfileDetails",
    }),
    ...mapGetters("user", {
      userRole: "getUserRole",
    }),
    ...mapState("user", {
      userID: (state) =>
        router.currentRoute.name === "my-profile"
          ? state.userDetails.user_id
          : router.currentRoute.params.userID,
    }),
    ...mapState("dashboard", {
      isActivated: (state) => state.userDetails.activated_by_admin,
    }),
    firstName() {
      return this.userDetails.first_name ? this.userDetails.first_name : "";
    },
    lastName() {
      return this.userDetails.last_name ? this.userDetails.last_name : "";
    },
    position() {
      return this.userDetails.position ? this.userDetails.position : "";
    },
    faculty() {
      return this.userDetails.faculty ? this.userDetails.faculty : "";
    },
    institutionName() {
      return this.userDetails.institution_name ? this.userDetails.institution_name : "";
    },
    institutionCampus() {
      return this.userDetails.institution_campus
        ? this.userDetails.institution_campus
        : "";
    },
    institutionState() {
      return this.userDetails.institution_state ? this.userDetails.institution_state : "";
    },
    institutionCountry() {
      return this.userDetails.institution_country
        ? this.userDetails.institution_country
        : "";
    },
    email() {
      return this.userDetails.user_email ? this.userDetails.user_email : "";
    },
    telasRole() {
      return this.userDetails.user_role ? this.userDetails.user_role : "";
    },
  },
  watch: {
    userID(val) {
      if (val !== undefined) {
        this.getUserDetail({ user_id: val });
      }
    },
    firstName(val) {
      return this.regForm.setFieldsValue({ firstName: val });
    },
    lastName(val) {
      return this.regForm.setFieldsValue({ lastName: val });
    },
    position(val) {
      this.regForm.setFieldsValue({ position: val });
    },
    faculty(val) {
      this.regForm.setFieldsValue({ faculty: val });
    },
    institutionName(val) {
      this.regForm.setFieldsValue({ institutionName: val });
    },
    institutionCampus(val) {
      this.regForm.setFieldsValue({ institutionCampus: val });
    },
    institutionState(val) {
      this.regForm.setFieldsValue({ institutionState: val });
    },
    institutionCountry(val) {
      this.regForm.setFieldsValue({ institutionCountry: val });
    },
    email(val) {
      this.regForm.setFieldsValue({ email: val });
    },
    telasRole(val) {
      this.regForm.setFieldsValue({ telasRole: val });
    },
    userDetails(val) {
      const userRoleStringArray = val.user_role.split("_");
      userRoleStringArray.shift();
      const userRole = userRoleStringArray.join(" ");
      this.dashboardTitle = `${userRole} Dashboard`;
    },
  },
  created() {
    this.regForm = this.$form.createForm(this, {
      onFieldsChange: (_, changedFields) => {
        this.$emit("change", changedFields);
      },
      mapPropsToFields: () => ({
        firstName: this.$form.createFormField({
          value: this.firstName,
        }),
        lastName: this.$form.createFormField({
          value: this.lastName,
        }),
        position: this.$form.createFormField({
          value: this.position,
        }),
        faculty: this.$form.createFormField({
          value: this.faculty,
        }),
        institutionName: this.$form.createFormField({
          value: this.institutionName,
        }),
        institutionCampus: this.$form.createFormField({
          value: this.institutionCampus,
        }),
        institutionState: this.$form.createFormField({
          value: this.institutionState,
        }),
        institutionCountry: this.$form.createFormField({
          value: this.institutionCountry,
        }),
        email: this.$form.createFormField({
          value: this.email,
        }),
        telasRole: this.$form.createFormField({
          value: this.telasRole,
        }),
      }),
    });
  },
  methods: {
    ...mapActions("user", {
      registerUser: "registerUser",
      updateUser: "updateUser",
    }),
    ...mapActions("dashboard", {
      getUserDetail: "getUserDetail",
    }),
    handleSubmit(e) {
      e.preventDefault();
      this.regForm.validateFields((err, values) => {
        const newValue = { ...values, user_id: this.userID };
        if (values.telasRole !== this.userDetails.user_role) {
          newValue.roleChanged = "yes";
        }
        if (!err) {
          this.updateUser(newValue);
        }
      });
    },
  },
  mounted() {
    this.getUserDetail({ user_id: this.userID });
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case "user/UPDATEUSER":
          this.successUpdate = true;
          if (this.isActivated === "no") {
            this.successMessage = `Thank you!  A copy of your user profile and
            role request has been emailed to you and the TELAS administrator
            who will review the request and get back to you`;
          }
          if (router.currentRoute.name === "my-profile") {
            this.successMessage = "You have updated your profile.";
          } else {
            this.successMessage = "User detail has been updated.";
          }
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
          this.errorMessage = "";
          break;
        case "user/UPDATEUSERERROR":
          this.errorMessage = state.common.messages.errors;
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
          this.successUpdate = false;
          break;
        default:
        // this.successUpdate = true;
      }
    });
  },
};
</script>
<style scoped lang="css">
.login-form-button {
  width: 100%;
}
</style>
